<app-breadcrumbs></app-breadcrumbs>
<div class="sidebar-style-9 service-details">
  <div class="section sigma_post-details">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="sigma_post-details-inner mb-md-80">
            <div class="entry-content">
              <a class="btn-link primary-color" href="javascript:void(0);" onclick="history.back();"> 
                <i class="fal fa-hand-point-left"></i> &nbsp; &nbsp;
                  Continue Shopping 
              </a>
              <br>
              <ng-container *ngIf="drug && drug.images && drug.images.length > 0">
                <img 
                  [src]="selectedImageIndex === 0 ? drug.images[0] : selectedImage" 
                  [alt]="drug.name" 
                  class="medical-test-image w-100">
              </ng-container>       
              <div class="row">
                <div class="col-md-12 image-carousel" *ngIf="drug && drug.images && drug.images.length > 1">
                  <div *ngFor="let image of drug.images; let i = index;">
                    <img [src]="image" [alt]="drug.name" (click)="selectImage(i)">
                  </div>
                </div>
              </div>                          
              <h4 class="entry-title">{{drug?.name}}</h4>
              <div class="drug-extra-details sigma_info-wrapper style-26">
                <div class="sigma_info style-26 drug-extra-details-inner">
                  <div class="sigma_info-title">
                    <span class="sigma_info-icon">
                      <i class="fal fa-money-check"></i>
                    </span>
                  </div>
                  <div class="sigma_info-description">
                    <p>{{ selectedQuantityType?.selling_price + ' UGX'}}</p>
                  </div>
                </div>
                <div class="sigma_info style-26 drug-extra-details-inner">
                  <div class="sigma_info-title">
                    <span class="sigma_info-icon">
                      <i 
                        class="fa fa-archive"
                        [ngClass]="{'fal fa-ban': selectedQuantityType?.is_in_stock === 0 }">
                      </i>
                    </span>
                  </div>
                  <div class="sigma_info-description">
                    <p class="availability" [ngClass]="{'out-of-stock': selectedQuantityType?.is_in_stock === 0 }">
                      {{ selectedQuantityType?.is_in_stock === 1 ? 'In Stock' : 'Out of Stock' }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="drug-info-container">
                <h5>Drug Information</h5>
                <div class="drug-info">
                  <div class="info-item">
                    <i class="fal fa-flask"></i>
                    <span><strong>Composition:</strong> {{ drug.composition }}</span>
                  </div>
                  <div class="info-item">
                    <i class="fal fa-globe"></i>
                    <span><strong>Country of Origin:</strong> {{ drug.country_of_origin }} </span>
                  </div>
                  <div class="info-item">
                    <i class="fal fa-calendar-alt"></i>
                    <span><strong>Expiry Date:</strong> {{ drug.expiry_date}}</span>
                  </div>
                  <div class="info-item">
                    <div *ngIf="drug && drug.quantity_types && drug.quantity_types.length > 0" class="quantity-types-section">
                      <h5>Available Quantities and Prices</h5>
                      <div class="quantity-select-controls">
                        <select 
                          class="form-control w-auto mb-2" 
                          [(ngModel)]="selectedQuantityType"
                          (ngModelChange)="onQuantityTypeChange($event)">
                          <option *ngFor="let qty of drug.quantity_types" [ngValue]="qty">
                            {{ qty.name }}
                          </option>
                        </select>
                        <span class="custom-arrow"></span>
                        <div class="quantity-price">
                          <strong>Price:</strong> {{ selectedQuantityType?.selling_price }} UGX
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>     
              <div class="drug-info-description" [innerHtml]="drug?.description"></div>
            </div>
          </div>
        </div>
        <!-- Sidebar Start -->
        <div class="col-lg-4">
          <app-service-sidebar
            [drug]="drug"
            [selectedQuantity]="selectedQuantityType"
            [cartItems]="cartItems"
            [isUpdate]="isUpdateDrugQuantityType"
            [productQuantities]="productQuantities"
            [isShowAddCart]="isShowAddCart"
            [isMedicalConsultation]="isMedicalConsultation">
          </app-service-sidebar>
        </div>
        <!-- Sidebar End -->
      </div>
    </div>
  </div>
</div>
